import type { V3 } from "backoffice-api"
import type { ProductTypeIdentifier } from "../../graphql"
import type { SharedItem } from "./types"

// The endpoint orders by id, not by the requested order.
export const orderedItems = (
  ids: string[],
  data: V3["getSharedItems"]["data"]
): SharedItem[] => {
  const byId = new Map(data.map((item) => [item.id, item]))

  return ids.flatMap((id) => {
    const item = byId.get(id)
    if (!item) return []

    return {
      id: item.id,
      title: item.title,
      thumbnail: item.thumbnail,
      productType: item.product_type_identifier as ProductTypeIdentifier,
    }
  })
}
